import React from "react";

export default function ProductDetailModal({
  product,
  onClose,
  onAddToCart,
  formatSize,
}) {
  if (!product) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        {/* Image & Title */}
        <div className="flex gap-4">
          <div className="relative h-28 w-28 shrink-0 overflow-hidden rounded-xl border border-gray-100 bg-gray-50">
            {product.image && (
              <img
                src={product.image}
                alt={product.name}
                className="h-full w-full object-cover"
              />
            )}
            <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-black/30 text-xs text-white">
              ♥
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="break-all text-sm font-bold leading-tight text-gray-900">
              {product.name}
            </h3>
          </div>
        </div>

        {/* Specifications Table */}
        <div className="mt-6">
          <h4 className="font-bold text-gray-900">Specifications</h4>
          <div className="mt-2 divide-y divide-gray-100 border-b border-t border-gray-100 text-xs text-gray-700">
            <div className="flex justify-between py-2.5">
              <span className="text-gray-500">SKU</span>
              <span className="font-semibold text-gray-900">
                {product.sku || "-"}
              </span>
            </div>
            <div className="flex justify-between py-2.5">
              <span className="text-gray-500">Application Type</span>
              <span className="font-semibold text-gray-900">
                {product.application_type || "-"}
              </span>
            </div>
            <div className="flex justify-between py-2.5">
              <span className="text-gray-500">Surface</span>
              <span className="font-semibold text-gray-900">
                {product.surface_type || "-"}
              </span>
            </div>
            <div className="flex justify-between py-2.5">
              <span className="text-gray-500">Size</span>
              <span className="font-semibold text-gray-900">
                {formatSize ? formatSize(product) : product.product_size || "-"}
              </span>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <div className="mt-6">
          <button
            type="button"
            onClick={() => {
              if (onAddToCart) onAddToCart(product);
              onClose();
            }}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-black py-2.5 text-xs font-medium text-white transition hover:bg-gray-800"
          >
            Add to cart 🛍️
          </button>
        </div>
      </div>
    </div>
  );
}